import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '../../services/baseQuery'
import { AvailableIntegration } from './types'

export const integrationApi = createApi({
  reducerPath: 'integrationApi',
  tagTypes: ['Integrations'],
  baseQuery: axiosBaseQuery({
    baseUrl: '/bff/tenant-integrations',
  }),
  endpoints: (build) => ({
    getAvailableIntegrations: build.query<AvailableIntegration[], void>({
      query: () => ({
        url: '/available',
        method: 'get',
      }),
      providesTags: ['Integrations'],
    }),
    connectIntegration: build.mutation<void, string>({
      query: (integrationProviderId) => ({
        url: '',
        method: 'post',
        data: { providerId: integrationProviderId },
      }),
      invalidatesTags: ['Integrations'],
    }),
  }),
})

export const { useGetAvailableIntegrationsQuery, useConnectIntegrationMutation } = integrationApi
